import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";

export interface LandingPage {
  id: number;
  subdomain: string;
  newsletter_name: string;
  url: string;
  deployed_at: string | null;
}

class LandingPageService {
  private getAuthHeaders() {
    return {
      Authorization: getAuthUser()?.accessToken,
    };
  }

  async list(): Promise<LandingPage[]> {
    const response = await axios.get(
      `${getApiUrlWithVersion()}/landing_pages`,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }
}

export default new LandingPageService();
